import './CustomerSettingsManager.scss';
import { ADMIN_DASHBOARD_COPY } from '@sonar-software/sonar-ts-constants';
import { createAsyncSelectors } from '@lib/selectors';
import { Button, Form, Input, InputNumber } from 'antd';
import { coreActions } from '@sonar-software/sonar-core';
import React, { useCallback, useEffect, useRef } from 'react';
import { useAction, useSonarSelector } from '@hooks';
const patchCustomerSelectors = createAsyncSelectors((state) => state.core.customers.byId.patch);
export const CustomerSettingsManager = (props) => {
    const { id, customer, searchDetails } = props;
    const formRefSalesforceAccountId = useRef(null);
    const formRefTimelineRetentionPeriod = useRef(null);
    const patchCustomer = useAction(coreActions.requestPatchCoreCustomersById);
    const isPatchingCustomer = useSonarSelector(patchCustomerSelectors.isRequested);
    const handleSubmitSalesforceAccountId = useCallback((values) => {
        var _a;
        if (searchDetails) {
            const { customerId, shardName } = searchDetails;
            patchCustomer({
                customerId: customerId,
                salesforceAccountId: (_a = values.salesforceAccountId) !== null && _a !== void 0 ? _a : null,
                shardName: shardName
            });
        }
    }, [patchCustomer, searchDetails]);
    const handleSubmitTimelineRetentionPeriod = useCallback((values) => {
        var _a;
        if (searchDetails) {
            const { customerId, shardName } = searchDetails;
            patchCustomer({
                customerId: customerId,
                shardName: shardName,
                timelineRetentionPeriod: (_a = values.timelineRetentionPeriod) !== null && _a !== void 0 ? _a : null
            });
        }
    }, [patchCustomer, searchDetails]);
    useEffect(() => {
        var _a, _b;
        if (customer) {
            (_a = formRefSalesforceAccountId.current) === null || _a === void 0 ? void 0 : _a.resetFields();
            (_b = formRefTimelineRetentionPeriod.current) === null || _b === void 0 ? void 0 : _b.resetFields();
        }
    }, [customer]);
    return (React.createElement("div", { className: 'customer-settings-manager', id: id },
        React.createElement("div", { className: 'h2' }, ADMIN_DASHBOARD_COPY.CUSTOMER_SETTINGS),
        React.createElement(Form, { className: 'inline-form-with-overhead-labels', colon: false, initialValues: { salesforceAccountId: customer === null || customer === void 0 ? void 0 : customer.salesforceAccountId }, layout: 'inline', onFinish: handleSubmitSalesforceAccountId, ref: formRefSalesforceAccountId },
            React.createElement(Form.Item, { label: ADMIN_DASHBOARD_COPY.SALESFORCE_ACCOUNT_ID, name: 'salesforceAccountId', rules: [
                    {
                        message: ADMIN_DASHBOARD_COPY.INVALID_SALESFORCE_ACCOUNT_ID,
                        pattern: /(^[a-zA-Z0-9]{15}$)|(^[a-zA-Z0-9]{18}$)/u,
                        type: 'string'
                    }
                ] },
                React.createElement(Input, null)),
            React.createElement(Button, { htmlType: 'submit', loading: isPatchingCustomer, type: 'primary' }, ADMIN_DASHBOARD_COPY.SUBMIT)),
        React.createElement(Form, { className: 'inline-form-with-overhead-labels', colon: false, initialValues: { timelineRetentionPeriod: customer === null || customer === void 0 ? void 0 : customer.timelineRetentionPeriod }, layout: 'inline', onFinish: handleSubmitTimelineRetentionPeriod, ref: formRefTimelineRetentionPeriod },
            React.createElement(Form.Item, { label: ADMIN_DASHBOARD_COPY.TIMELINE_RETENTION_PERIOD, name: 'timelineRetentionPeriod' },
                React.createElement(InputNumber, { max: 1825, min: 0 })),
            React.createElement(Button, { htmlType: 'submit', loading: isPatchingCustomer, type: 'primary' }, ADMIN_DASHBOARD_COPY.SUBMIT))));
};
